export enum Variant {
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
}

export enum PositionEnum {
  GK = 'gk',
  LD = 'ld',
  CD = 'cd',
  RD = 'rd',
  LM = 'lm',
  DM = 'dm',
  CM = 'cm',
  OM = 'om',
  RM = 'rm',
  LW = 'lw',
  FW = 'fw',
  RW = 'rw',
}

export enum PositionAreaEnum {
  GK = 'gk',
  DF = 'df',
  MF = 'mf',
  AT = 'at',
}

export type LineupEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;

export enum WeekdayEnum {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
}

export enum MonthEnum {
  JANUARY = 0,
  FEBRUARY = 1,
  MARCH = 2,
  APRIL = 3,
  MAI = 4,
  JUNE = 5,
  JULY = 6,
  AUGUST = 7,
  SEPTEMBER = 8,
  OCTOBER = 9,
  NOVEMBER = 10,
  DECEMBER = 11,
}

export {CountryEnum} from './CountryEnum';
export {RegionEnum} from './RegionEnum';
export {MatchResultEnum} from './MatchResultEnum';
